import React from 'react';
import * as DatesUtils from '../../utils/dates';
import { Languages, AuthRoles } from '../../config';

const CONFIGURATION = {};

export default CONFIGURATION;

// export const TableColumns = [
//   {
//     label: '#',
//     id: 'notification_id',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },
//   {
//     label: 'VAT Number',
//     id: 'vat_num',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Type',
//     id: 'notification_type',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Title',
//     id: 'notification_title',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Message',
//     id: 'notification_message',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },
//   {
//     label: 'Seen',
//     id: 'is_read',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue ? 'Yes' : 'No'}</React.Fragment>
//     ),
//     inData: true,
//   },
//   // {
//   //   label: 'Actions',
//   //   align: 'center',
//   //   id: 'action1',
//   //   render: (
//   //     rowIndex: number,
//   //     cellValue: any,
//   //     columnIndex: number,
//   //     data: any
//   //   ) => (
//   //     <ActionsBlock
//   //       rowIndex={rowIndex}
//   //       data={data}
//   //       dataid={data[rowIndex].notification_id}
//   //     />
//   //   ),
//   //   inData: false,
//   // },
// ];

// interface ITableDefaultFetchValues {
//   TABLE_DEFAULT_PAGE: number;
//   TABLE_DEFAULT_PAGE_SIZE: number;
//   TABLE_DEFAULT_ORDER: 'desc' | 'asc';
//   TABLE_DEFAULT_SORT_KEY: string;
// }

// export const TableDefaultFetchValues: ITableDefaultFetchValues = {
//   TABLE_DEFAULT_PAGE: 0,
//   TABLE_DEFAULT_PAGE_SIZE: 10,
//   TABLE_DEFAULT_ORDER: 'desc',
//   TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
// };

export const Translations = {
  page_title: {
    [Languages.Greek]: 'VAT Returns',
    [Languages.English]: 'VAT Returns',
  },
  title: {
    [Languages.Greek]: 'VAT Returns Received',
    [Languages.English]: 'VAT Returns Received',
  },
  description: {
    [Languages.Greek]:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec blandit gravida ligula, a molestie ligula blandit vel. Aenean urna turpis, pellentesque sit amet egestas eu, viverra et ligula. Vestibulum rhoncus arcu augue, eu semper dui pellentesque non.',
    [Languages.English]:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec blandit gravida ligula, a molestie ligula blandit vel. Aenean urna turpis, pellentesque sit amet egestas eu, viverra et ligula. Vestibulum rhoncus arcu augue, eu semper dui pellentesque non.',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dasbhoard',
    [Languages.English]: 'Go to dasbhoard',
  },
  vat_number: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  originatingCountry: {
    [Languages.Greek]: 'MSID Country',
    [Languages.English]: 'MSID Country',
  },
  schemeType: {
    [Languages.Greek]: 'Scheme Type',
    [Languages.English]: 'Scheme Type',
  },
  state: {
    [Languages.Greek]: 'State',
    [Languages.English]: 'State',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
  version: {
    [Languages.English]: 'VAT Return Version:',
    [Languages.Greek]: 'VAT Return Version:',
  },
  change_date: {
    [Languages.English]: 'Change Date:',
    [Languages.Greek]: 'Change Date:',
  },
  total_msid_services: {
    [Languages.English]: 'VAT Amount for Services supplied from the MSID (€):',
    [Languages.Greek]: 'VAT Amount for Services supplied from the MSID (€):',
  },
  total_msid_goods: {
    [Languages.English]: 'VAT Amount for Goods supplied from the MSID (€):',
    [Languages.Greek]: 'VAT Amount for Goods supplied from the MSID (€):',
  },
  total_msest_services: {
    [Languages.English]:
      'VAT Amount for Services supplied from Fixed Establishments (€):',
    [Languages.Greek]:
      'VAT Amount for Services supplied from Fixed Establishments (€):',
  },
  total_msest_goods: {
    [Languages.English]:
      'VAT Amount for Goods supplied from Fixed Establishments (€):',
    [Languages.Greek]:
      'VAT Amount for Goods supplied from Fixed Establishments (€):',
  },
  total_corrections: {
    [Languages.English]: 'Total Corrections (€):',
    [Languages.Greek]: 'Total Corrections (€):',
  },
  total_vat_amount: {
    [Languages.English]: 'Total VAT Amount (€):',
    [Languages.Greek]: 'Total VAT Amount (€):',
  },
  total_vat_amount_payable: {
    [Languages.English]: 'Total VAT Amount Payable (€):',
    [Languages.Greek]: 'Total VAT Amount Payable (€):',
  },
  total_vat_amount_paid: {
    [Languages.English]: 'Total VAT Amount Paid (€):',
    [Languages.Greek]: 'Total VAT Amount Paid (€):',
  },
  total_amount_to_be_reimbursed: {
    [Languages.English]: 'Total Amount To Be Reimbursed (€):',
    [Languages.Greek]: 'Total Amount To Be Reimbursed (€):',
  },
  total_amount_reimbursed: {
    [Languages.English]: 'Total Amount Reimbursed (€):',
    [Languages.Greek]: 'Total Amount Reimbursed (€):',
  },
  payment_details_title: {
    [Languages.English]: 'Payment Details',
    [Languages.Greek]: 'Payment Details',
  },
  vat_return_details_title: {
    [Languages.English]: 'VAT Return Details',
    [Languages.Greek]: 'VAT Return Details',
  },
};
